import { render, staticRenderFns } from "./ProductSelectBottomFooter.vue?vue&type=template&id=7bda0e60&scoped=true"
import script from "./ProductSelectBottomFooter.vue?vue&type=script&lang=js"
export * from "./ProductSelectBottomFooter.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectBottomFooter.vue?vue&type=style&index=0&id=7bda0e60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda0e60",
  null
  
)

export default component.exports